"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuToolbarRow = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ToolbarMenuItemTerminal_1 = require("../../Toolbar/ToolbarMenu/ToolbarMenuItemTerminal");
const ContextItemNested_1 = require("../ContextItemNested");
const ContextMenuPane_1 = require("./ContextMenuPane");
const context_1 = require("./context");
const Space_1 = require("../../../3-list-item/Space");
const useBehaviorSubject_1 = require("../../../hooks/useBehaviorSubject");
const MoveToViewport_1 = require("../../../utils/popup/MoveToViewport");
const ContextMenuToolbarRow = ({ path, depth, openPanel }) => {
    const parent = path[path.length - 2];
    const item = path[path.length - 1];
    const selected = (0, useBehaviorSubject_1.useBehaviorSubject)(openPanel.selected$);
    const state = (0, context_1.useContextMenu)();
    const id = parent.id ?? parent.name;
    const open = selected === id;
    const buttons = [];
    const children = item.children;
    const length = children?.length ?? 0;
    const max = Math.min(item.expand ?? 4, 4);
    for (let i = 0; i < length; i++) {
        if (i >= max)
            break;
        const child = children[i];
        if (child.icon)
            buttons.push(React.createElement(React.Fragment, { key: child.id || child.name || i },
                React.createElement(ToolbarMenuItemTerminal_1.ToolbarMenuItemTerminal, { item: child, small: true, fill: !open }),
                React.createElement(Space_1.Space, { horizontal: true, size: -2 })));
    }
    return (React.createElement("div", { "data-menu-row": true, "data-menu-id": id, style: { position: 'relative' } },
        React.createElement(ContextItemNested_1.ContextItemNested, { key: item.id || item.name, open: open, inset: true, more: item.more, nested: !!children, icon: item.icon?.() ??
                (item.iconBig ? (React.createElement("div", { style: { transformOrigin: '0 0', transform: 'scale(.25)' } }, item.iconBig?.())) : (void 0)), right: item.right?.(), danger: item.danger, onClick: item.onSelect
                ? (event) => state.execute(item, event)
                : children
                    ? () => {
                        state.select(path.slice(0, -2), parent);
                    }
                    : void 0, renderPane: () => (React.createElement(MoveToViewport_1.MoveToViewport, null,
                React.createElement(ContextMenuPane_1.ContextMenuPane, { header: void 0, menu: parent, path: [parent], depth: depth + 1, inset: true, onEsc: () => openPanel.deselect() }))), onMouseEnter: () => openPanel.onMouseMove(id), onMouseMove: () => openPanel.onMouseMove(id), onMouseLeave: openPanel.onMouseLeave },
            React.createElement("div", null, "\u00A0")),
        React.createElement("div", { style: { position: 'absolute', top: 2, left: 8 } }, buttons)));
};
exports.ContextMenuToolbarRow = ContextMenuToolbarRow;
